import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
const titleFontSizeMap = {
    '2xl': 'fontSize.huge',
    xl: 'fontSize.huge',
    lg: 'fontSize.large',
    md: 'fontSize.medium',
    sm: 'fontSize.small',
    xs: 'fontSize.small',
    xxs: 'fontSize.tiny',
};
const subtitleFontSizeMap = {
    '2xl': 'fontSize.small',
    xl: 'fontSize.small',
    lg: 'fontSize.tiny',
    md: 'fontSize.tiny',
    sm: 'fontSize.tiny',
    xs: 'fontSize.tiny',
    xxs: 'fontSize.tiny',
};
const containerGapSizeMap = {
    '2xl': 'spacing.md',
    xl: 'spacing.md',
    lg: 'spacing.md',
    md: 'spacing.md',
    sm: 'spacing.md',
    xs: 'spacing.sm',
    xxs: 'spacing.sm',
};
const textsContainerGapSizeMap = {
    '2xl': pxToRem(4),
    xl: pxToRem(2),
    lg: pxToRem(2),
    md: pxToRem(0),
    sm: pxToRem(0),
    xs: pxToRem(2),
    xxs: pxToRem(2),
};
const textOnSameLine = (props) => {
    if (props.$alignment !== 'horizontal') {
        return false;
    }
    if (props.$size === 'xs' || props.$size === 'xxs') {
        return true;
    }
    return false;
};
const Text = styled.span `
  margin: 0;
  line-height: 110%;

  ${(props) => props.$truncate &&
    css `
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;
export const Title = styled(Text) `
  color: ${themeGet('colors.text.300')};
  font-weight: ${themeGet('fontWeight.medium')};
`;
export const Subtitle = styled(Text) `
  color: ${themeGet('colors.text.100')};
  font-weight: ${themeGet('fontWeight.regular')};
`;
export const TextContainer = styled.div `
  display: flex;
  min-width: 0;
`;
export const Container = styled.div `
  display: flex;
  overflow: hidden;
  align-items: ${({ $alignment }) => ($alignment === 'vertical-left' ? 'flex-start' : 'center')};
  flex-direction: ${({ $alignment }) => ($alignment === 'horizontal' ? 'row' : 'column')};
  text-align: ${({ $alignment }) => ($alignment === 'vertical' ? 'center' : 'start')};
  gap: ${({ $size }) => $size && themeGet(containerGapSizeMap[$size])};

  ${TextContainer} {
    align-items: ${(props) => textOnSameLine(props) && 'flex-end'};
    flex-direction: ${(props) => (textOnSameLine(props) ? 'row' : 'column')};
    gap: ${({ $size }) => textsContainerGapSizeMap[$size]};
  }

  ${Title} {
    font-size: ${({ $size }) => themeGet(titleFontSizeMap[$size])};
  }

  ${Subtitle} {
    font-size: ${({ $size }) => themeGet(subtitleFontSizeMap[$size])};
  }
`;
